export function prefersReducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function fadeAnimate(opts: {
  element: HTMLElement | null; from: number; to: number
  duration: number; easing?: string; fill?: FillMode
}): Animation | null {
  if (!opts.element) return null
  if (prefersReducedMotion()) { opts.element.style.opacity = String(opts.to); return null }
  return opts.element.animate(
    [{ opacity: opts.from }, { opacity: opts.to }],
    { duration: opts.duration, easing: opts.easing ?? 'ease', fill: opts.fill ?? 'forwards' }
  )
}

/** Запускает анимации последовательно — каждая стартует только после onfinish предыдущей. */
export function chainAnimations(fns: Array<() => Animation | null>): Promise<void> {
  return fns.reduce<Promise<void>>(
    (prev, fn) => prev.then(() => new Promise<void>((resolve) => {
      const a = fn()
      if (!a) { resolve(); return }
      a.onfinish = () => resolve()
      a.oncancel = () => resolve()
    })),
    Promise.resolve()
  )
}
